import { Box, InfoIcon, Text, ToggleSwitch } from "@wix/design-system";
import React, { useContext } from "react";
import { ZIndexContext } from "./../../ricos-context";
import classes from "../statics/styles/toggle-button-scss";
const ToggleButton = ({
  checked,
  onChange,
  title,
  infoContent,
  dataHook,
  size,
  toolTipSize = "medium",
  tooltipAppendTo,
  disabled
}) => {
  const zIndexService = useContext(ZIndexContext);
  return /* @__PURE__ */ React.createElement(Box, { verticalAlign: "middle", align: "space-between", className: classes.root, gap: "9px" }, infoContent ? /* @__PURE__ */ React.createElement(Box, { verticalAlign: "middle", gap: "SP1" }, /* @__PURE__ */ React.createElement(Text, { size: "small" }, title), /* @__PURE__ */ React.createElement(
    InfoIcon,
    {
      size: "small",
      content: infoContent,
      tooltipProps: {
        appendTo: tooltipAppendTo ?? ((el) => Boolean(el.getAttribute("data-hook")?.includes("ricos-portal"))),
        zIndex: zIndexService.getZIndex("TOOLTIP"),
        size: toolTipSize,
        enterDelay: 300
      }
    }
  )) : /* @__PURE__ */ React.createElement(Text, { size: "small" }, title), /* @__PURE__ */ React.createElement(
    ToggleSwitch,
    {
      size,
      checked,
      onChange,
      dataHook,
      disabled
    }
  ));
};
export {
  ToggleButton
};
//# sourceMappingURL=toggle-button.js.map
